enum TaskTypes {
  fileUpload = 1,
  example1 = 2,
}
export default TaskTypes;
